export const environment = {
    production: true,
    instagram_token: 'INSTA_TOKEN',
    stripe_token: 'STRIPE_TOKEN',
    paypal_token: 'PAYPAL_TOKEN',
    api_url: 'https://tradebrisk.in/api/v1/',
    cashfree_sandbox: 'https://sdk.cashfree.com/js/ui/1.0.26/dropinClient.prod.js',
    //api_url: 'https://demo.equibiz.in/api/v1/',
    //cashfree_sandbox: 'https://sdk.cashfree.com/js/ui/1.0.26/dropinClient.sandbox.js',
    keyforencdec: '123456$#@$^@1ERF',
    firebase: {
        apiKey: "AIzaSyCtIgWC1wjL9yDavSsIHq39zh8Ck8KC1Uw",
        authDomain: "equibiz-37a6f.firebaseapp.com",
        projectId: "equibiz-37a6f",
        storageBucket: "equibiz-37a6f.appspot.com",
        messagingSenderId: "1058224171167",
        appId: "1:1058224171167:web:22d4b44551052f6b131aaa",
        measurementId: "G-Z7QH6B3H3N",
        vapidKey: "BC4ymtuRTt0721tu1aXtHb6xvEFQXHD3xtibQx9gQNTCLRn0FQ5c9RfvYdZMGVGIZTkgIqSJU7yFvsCupqrGqdg"
    }
};